import React, { useState, useEffect } from 'react';

function EditCheckBox( { index, boxMeasured, boxChecked, onBoxClick } ) {
    const [measured, setMeasured] = useState( 0 );
    const [checked,  setChecked]  = useState( 0 );

    useEffect(() => {
        if (typeof boxMeasured !== 'undefined') {
            setMeasured(Number(boxMeasured));
        }
    }, [boxMeasured]); // Runs when initialData changes

    useEffect(() => {
        if (typeof boxChecked !== 'undefined') {
            setChecked(Number(boxChecked));
        }
    }, [boxChecked]); // Runs when initialData changes

    const handleClick = () => {
            onBoxClick(index);
    }
    
    return(<div className={'check-box-' + measured + '-' + checked} onClick={handleClick}>&nbsp;</div>);
}

export default EditCheckBox;
